module.exports = __webpack_public_path__ + "static/10mm-logo-beb1c84c4447bdc9ef1c168e6943a7a3.svg";